var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlympicRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4698 28.5795C22.9381 28.5795 28.9922 22.6057 28.9922 15.2366C28.9922 7.86742 22.9381 1.89355 15.4698 1.89355C8.00159 1.89355 1.94739 7.86742 1.94739 15.2366C1.94739 22.6057 8.00159 28.5795 15.4698 28.5795Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2352 41.9237C38.7034 41.9237 44.7576 35.9498 44.7576 28.5807C44.7576 21.2116 38.7034 15.2377 31.2352 15.2377C23.767 15.2377 17.7128 21.2116 17.7128 28.5807C17.7128 35.9498 23.767 41.9237 31.2352 41.9237Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7652 41.9237C70.2335 41.9237 76.2877 35.9498 76.2877 28.5807C76.2877 21.2116 70.2335 15.2377 62.7652 15.2377C55.297 15.2377 49.2428 21.2116 49.2428 28.5807C49.2428 35.9498 55.297 41.9237 62.7652 41.9237Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0002 28.5795C54.4684 28.5795 60.5226 22.6057 60.5226 15.2366C60.5226 7.86742 54.4684 1.89355 47.0002 1.89355C39.5319 1.89355 33.4777 7.86742 33.4777 15.2366C33.4777 22.6057 39.5319 28.5795 47.0002 28.5795Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5305 28.5795C85.9987 28.5795 92.0529 22.6057 92.0529 15.2366C92.0529 7.86742 85.9987 1.89355 78.5305 1.89355C71.0623 1.89355 65.0081 7.86742 65.0081 15.2366C65.0081 22.6057 71.0623 28.5795 78.5305 28.5795Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicRings);
export default __webpack_public_path__ + "static/media/olympic-rings.6285dc0d0e3660ee2e41d258bd2ddfe0.svg";
export { ForwardRef as ReactComponent };